import { JuloUpdateEntry } from "./types"

export const onboardingEntry: JuloUpdateEntry = {
  slug: "2026-05-24-onboarding",
  date: "2026-05-24",
  title: "Ny sida: Onboarding",
  description:
    "Ni hittar nu en ny sida i sidomenyn — [Onboarding](/onboarding) — med korta filmer som går igenom prissättning, butiksinställningar, mottagning och besiktning. Bocka av varje film när ni har sett den. Den lila siffran i menyn visar hur många filmer ni har kvar att titta på.\n\nÄr något fortfarande oklart, eller vill ni att vi gör en film om ett annat ämne? Skriv till oss i [Chatta med Julo](/support-chat).",
}
